import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import ReportsTabSection from "../components/landing/ReportsTabSection";

/**
 * Public /reports page — every premium report on a single shareable URL.
 * No login required to browse; each card opens the dedicated report page
 * where the user can generate the report as a guest or signed-in user.
 */
export default function ReportsPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-white" data-testid="reports-page">
      <div className="border-b border-amber-100 bg-white sticky top-0 z-30 backdrop-blur supports-[backdrop-filter]:bg-white/85">
        <div className="max-w-6xl mx-auto px-4 h-14 flex items-center justify-between">
          <button
            onClick={() => navigate("/")}
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#1E3A5F] hover:text-amber-700 transition-colors"
            data-testid="reports-page-back"
          >
            <ArrowLeft size={14} weight="bold" /> Back to home
          </button>
          <span className="text-[10px] uppercase tracking-[0.22em] text-amber-700 font-bold">
            Premium Reports
          </span>
        </div>
      </div>
      <ReportsTabSection />
    </div>
  );
}
